import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, HttpModule, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { configURI, configURI1 } from '../../../shared/apiUrlConfig';
// import { InsuranceDoc } from '../../model/insurance.model'
// import { APP_ID_RANDOM_PROVIDER } from '@angular/core/src/application_tokens';
import { BehaviorSubject } from 'rxjs/BehaviorSubject'
// import { HttpHeaders } from '@angular/common/http';
import { BoundElementPropertyAst } from '@angular/compiler';
import { UserFriendlyMsgs } from '../../app.user-msgs';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class ParLicenseService {
  url = environment.configURI; 
  load;
  loginId;
  constructor(private httpClient: HttpClient, private http: Http, private userFriendlyMsgs: UserFriendlyMsgs) {
    this.load = new BehaviorSubject('initial');
   }

  // headers = new Headers({
  //                         'x-access-token': localStorage.getItem('Token'),
  //                         'Cache-Control': 'no-cache',
  //                         'Pragma': 'no-cache',
  //                         'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
  //                      });
  // options = new RequestOptions({ headers: this.headers });

  // httpClientHeaderOptions = {
  //   headers: new HttpHeaders({
  //     'x-access-token': localStorage.getItem('Token'),
  //     'Cache-Control': 'no-cache',
  //     'Pragma': 'no-cache',
  //     'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
  //   })
  // };

  getLicenseDocTypes() {
    // this.headers = new Headers({
    //   // 'x-access-token': localStorage.getItem('Token'),
    //   'Cache-Control': 'no-cache',
    //   'Pragma': 'no-cache',
    //   'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    // });
    // this.options = new RequestOptions({ headers: this.headers });
    //this.options.headers.set('x-access-token', localStorage.getItem('Token'));
    // return this.http.get(this.url + '/DocumentTypes/GetDocumentTypesByCategory?Category=parlicense', this.options)
    return this.httpClient.get(this.url + '/documents/GetDocumentTypesByCategory?Category=PARLICENSE').catch(this.userFriendlyMsgs.errorHandler)
  }

  getLicenseDocs() {
    // this.headers = new Headers({
    //   // 'x-access-token': localStorage.getItem('Token'),
    //   'Cache-Control': 'no-cache',
    //   'Pragma': 'no-cache',
    //   'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    // });
    // this.options = new RequestOptions({ headers: this.headers });
    //this.options.headers.set('x-access-token', localStorage.getItem('Token'));
    let role = parseInt(localStorage.getItem("RoleVal"))
    if(role === 8){
          // return this.http.get(this.url + '/parlicense/getalllicensedocs', this.options)
          return this.httpClient.get(this.url + '/client/par/license').catch(this.userFriendlyMsgs.errorHandler)
    }else{
          // return this.http.get(this.url + '/parlicense/getalllicensedocs', this.options)
          return this.httpClient.get(this.url + '/par/license').catch(this.userFriendlyMsgs.errorHandler)
    }
  }

  createNewParLicense(data) {
    // this.headers = new Headers({
    //   // 'x-access-token': localStorage.getItem('Token'),
    //   'Cache-Control': 'no-cache',
    //   'Pragma': 'no-cache',
    //   'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    // });
    // this.options = new RequestOptions({ headers: this.headers });
    //this.options.headers.set('x-access-token', localStorage.getItem('Token'));
    this.loginId = localStorage.getItem('loginID');
    const body = {
      document_type_code: data.documentType,
      document_type_name: data.documentName,
      file_name: data.fileName,
      expiration_date: data.expirationDate,
      document_link: data.documentLink,
      issue_date: data.issueDate,
      issue_state: data.issueState,
      license_number: data.licenseNumber,
      upload_date: data.uploadDate,
      created_by: this.loginId,
    }

    //  return this.http.post(this.url + '/parlicense/addparlicense', body, this.options)
    return this.httpClient.post(this.url + '/par/license', body).catch(this.userFriendlyMsgs.errorHandler)
  }

  updateParLicense(data) {
    // this.headers = new Headers({
    //   // 'x-access-token': localStorage.getItem('Token'),
    //   'Cache-Control': 'no-cache',
    //   'Pragma': 'no-cache',
    //   'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    // });
    // this.options = new RequestOptions({ headers: this.headers });
    //this.options.headers.set('x-access-token', localStorage.getItem('Token'));
    this.loginId = localStorage.getItem('loginID');
    const body = {
      document_type_code: data.documentType,
      document_type_name: data.documentName,
      file_name: data.fileName,
      expiration_date: data.expirationDate,
      document_link: data.documentLink,
      issue_date: data.issueDate,
      issue_state: data.issueState,
      license_number: data.licenseNumber,
      upload_date: data.uploadDate,
      updated_by: this.loginId
    }

    return this.httpClient.put(this.url + '/par/license/document/' + data.docId, body).catch(this.userFriendlyMsgs.errorHandler)
  }

  deleteParLicense(data){
    // this.headers = new Headers({
    //   // 'x-access-token': localStorage.getItem('Token'),
    //   'Cache-Control': 'no-cache',
    //   'Pragma': 'no-cache',
    //   'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    // });
    // this.options = new RequestOptions({ headers: this.headers });
    //this.options.headers.set('x-access-token', localStorage.getItem('Token'));
    // return this.http.delete(this.url + '/parlicense/deletelicensedoc?docid=' + data._id, this.options)
    return this.httpClient.delete(this.url + '/par/license/document/' + data._id).catch(this.userFriendlyMsgs.errorHandler)
  }
}



// WEBPACK FOOTER //
// ./src/app/services/par_license/par-license.service.ts